import { TaskState } from '../../../../aumico-lib-cpmm-fe/src/lib';

export interface IssueDetailDto {
    issueId: string;
    name: string;
    state: TaskState;
    dueDate?: Date;
}
